import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import './style.css'

// 权限指令 + 认证状态
import { vPermission } from './directives/permission'
import { restoreAuth } from './config/auth'
import { initDictStore } from './config/dictStore'

const app = createApp(App)

// 注册所有图标
if (ElementPlusIconsVue && typeof ElementPlusIconsVue === 'object') {
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
}

// 注册 v-permission 指令
app.directive('permission', vPermission)

app.use(ElementPlus, { locale: zhCn })

Promise.all([
  restoreAuth().catch(() => false),
  initDictStore().catch(() => {}),
]).finally(() => {
  app.use(router)
  app.mount('#app')
})
